export default "__VITE_ASSET__DqlWhtbx__"